import { defineMessages } from 'react-intl';

export default defineMessages({
    creatingYourOfferingMessage: {
        id: 'quoteandbind.eu.directives.MultiQuoteView.Please wait while we create your offering...',
        defaultMessage: 'Please wait while we create your offering...'
    },
    policyLevelCoverages: {
        id: 'quoteandbind.eu.directives.MultiQuoteView.Policy Level Coverages',
        defaultMessage: 'Policy Level Coverages'
    }
});
